/**
 * Back-to-top button: shows when user has scrolled halfway down the page
 */
export function initBackToTop() {
  const btn = document.querySelector("[data-back-to-top]");
  if (!btn) return;

  const scrollThreshold = 0.10;

  function updateVisibility() {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollHeight <= 0) {
      btn.classList.remove("is-visible");
      return;
    }
    const scrolled = window.scrollY / scrollHeight;
    if (scrolled >= scrollThreshold) {
      btn.classList.add("is-visible");
    } else {
      btn.classList.remove("is-visible");
    }
  }

  window.addEventListener("scroll", updateVisibility, { passive: true });
  updateVisibility();

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector("#main")?.scrollIntoView({ behavior: "smooth" });
  });
}
